<template>
    <div id="ModalFile" class="modal fade in my-0" data-backdrop="static" data-keyboard="false" role="dialog">
        <div class="modal-dialog modal-el">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title">Detalhes do arquivo: <strong>{{arquivo.arquivo_nome}}</strong>
                    </p>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="card card-outline card-outline-tabs" :class="appLayout.card">
                        <div class="card-header p-0 border-bottom-0">
                            <div class="nav-tabs-custom" role="tabpanel">
                                <!-- Nav tabs -->
                                <ul class="nav nav-tabs" role="tablist">
                                    <li role="presentation" class="nav-item">
                                        <a class="nav-link active" @click="refreshFile()" href="#tabArquivo"
                                            aria-controls="tabArquivo" role="tab" data-toggle="tab"><i
                                                class="fa fa-file-pdf-o"></i> Arquivo</a>
                                    </li>
                                    <li role="presentation" class="nav-item">
                                        <a class="nav-link" href="#tabHistorico" aria-controls="tabHistorico" role="tab"
                                            data-toggle="tab"><i class="fa fa-history"></i> Histórico</a>
                                    </li>
                                    <li role="presentation" class="nav-item">
                                        <a class="nav-link" href="#tabDetalhes" aria-controls="tabDetalhes" role="tab"
                                            data-toggle="tab"><i class="fa fa-eye"></i> Detalhes</a>
                                    </li>
                                    <li role="presentation" class="nav-item">
                                        <a class="nav-link" href="#tabAssinaturas" aria-controls="tabAssinaturas"
                                            role="tab" data-toggle="tab"><i class="fa fa-pencil"></i> Assinaturas</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-body">
                                <div class="tab-content">
                                    <div role="tabpanel" class="tab-pane active" id="tabArquivo">
                                        <iframe type="application/pdf" id="fileStream" :src="fileStream" width="100%"
                                            height="500px" name="fileStream"></iframe>
                                    </div>
                                    <div role="tabpanel" class="tab-pane" id="tabHistorico">
                                        <div class="table-responsive">
                                            <table id="tabelaProdutos" class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Evento</th>
                                                        <th>Usuário</th>
                                                        <th>Data</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(evento, i) in arquivo.eventos" :key="i">
                                                        <td><span v-html="evento.evento"></span></td>
                                                        <td><span v-if="evento.usuario">{{evento.usuario.nome}}</span></td>
                                                        <td>{{formatDate(evento.created_at)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div role="tabpanel" class="tab-pane" id="tabDetalhes">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <p>NOME: <b>{{arquivo.arquivo_nome}}</b></p>
                                                <p>EXTENSÃO: <b>{{arquivo.arquivo_extensao}}</b></p>
                                                <p>TAMANHO: <b>{{arquivo.arquivo_tamanho}}kbs</b></p>
                                                <p>HASH: <b>{{arquivo.arquivo_hash}}</b></p>
                                                <p>URL: <b>{{arquivo.arquivo_url}}</b></p>
                                                <p>CRIADO EM: <b>{{formatDate(arquivo.created_at)}}</b></p>
                                                <p>DATA LIMITE PARA ASSINAR: <b>{{formatDate(arquivo.expired_at)}}</b></p>
                                            </div>
                                            <div class="col-md-4">
                                                <p>Validador Público: </p> <b>{{arquivo.id}}</b>
                                                <img :src="arquivo.qrCode" />
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" class="tab-pane" id="tabAssinaturas">
                                        <div class="table-responsive">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th v-if="arquivo.habilitar_ordem">Ordem</th>
                                                        <th>Nome</th>
                                                        <th>E-mail</th>
                                                        <th>Tipo Assinatura</th>
                                                        <th>Solicitado em</th>
                                                        <th>Assinado em</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(assinatura, i) in arquivo.assinaturas" :key="i">
                                                        <td v-if="arquivo.habilitar_ordem">{{assinatura.ordem}}</td>
                                                        <td> <i v-if="assinatura.assinado"
                                                                class="fa fa-check-circle text-green"></i>
                                                            <i v-else class="fa fa-times-circle text-red"></i>
                                                            {{assinatura.assinatura_nome}}</td>
                                                        <td>{{assinatura.assinatura_email}}</td>
                                                        <td>{{getTipoAssinatura(assinatura.assinatura_tipo, assinatura.assinado)}}
                                                        </td>
                                                        <td>{{formatDate(assinatura.created_at)}}</td>
                                                        <td>{{formatDate(assinatura.assinado_em)}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" data-dismiss="modal" class="btn btn-default"><i class="fa fa-times"></i>
                        {{$t('words.close')}} </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                fileStream: null,
                arquivo: {
                    eventos: [],
                    assinaturas: []
                }
            }
        },
        beforeMount() {
            this.formatDate = this.formatDate.bind(this);
        },
        methods: {
            refreshFile() {
                document.getElementById('fileStream').contentDocument.location.reload();
            }
        }
    };
</script>